import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-[hsl(0,0%,5%)]">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 className="text-3xl font-bold text-white mb-8" style={{ fontFamily: 'Space Grotesk' }}>Impressum</h1>
        <div className="text-white/60 text-sm leading-relaxed space-y-6">
          <div>
            <h2 className="text-lg font-semibold text-white mb-2">Angaben gemäß § 5 TMG</h2>
            <p>EHV Dresden Devils e.V.<br />c/o BSKP<br />Fetscherstraße 29<br />01307 Dresden</p>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white mb-2">Vertreten durch</h2>
            <p>Präsident: Norman Bradler<br />Vizepräsident: Martin Rost</p>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white mb-2">Kontakt</h2>
            <p>Ansprechpartner: Norman Bradler (Präsident)<br />E-Mail: <a href="mailto:Dresden.devils@gmail.com" className="text-[#46C7FF] hover:text-[#A9E7FF]">Dresden.devils@gmail.com</a></p>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white mb-2">Vereinsregister</h2>
            <p>Eingetragen im Vereinsregister.<br />Registergericht: Amtsgericht Dresden</p>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white mb-2">Haftungsausschluss</h2>
            <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
